import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  template: `
    <div>
      <ng-container>
        @if (data && data !== 'N/A') {
          <i class="fa fa-circle-check"></i>
        }
        @if (!data && data !== 'N/A') {
          <i class="fa fa-circle-xmark"></i>
        }
        @if (data === 'N/A') {
          <span>N/A</span>
        }
      </ng-container>
    </div>
    `,
  styleUrls: ['./boolean-cell.component.scss'],
})
export class BooleanCellComponent {
  @Input() data: any;
}
